<template>
<div>
  <h4>{{ $t('message.partners.head') }}</h4>
  <vs-divider></vs-divider>
  <vs-tabs>
    <vs-tab :label="$t('message.partners.partners')">
      <Internal />
    </vs-tab>
  </vs-tabs>
</div>
</template>

<script>
import Internal from '@/layouts/components/partners/Internal'
export default {
  name: 'Partners',
  components: { Internal }
}
</script>

<style scoped>

</style>
